import React from 'react';
import { SubSkill } from '../types';

interface SkillTooltipProps {
  subSkill: SubSkill;
  isVisible: boolean;
  position: { x: number; y: number };
}

const SkillTooltip: React.FC<SkillTooltipProps> = ({ subSkill, isVisible, position }) => {
  if (!isVisible) return null;

  return (
    <div 
      className="skill-tooltip"
      style={{
        left: position.x,
        top: position.y,
      }}
    >
      <div className="skill-tooltip-content">
        <h4 className="skill-tooltip-title">{subSkill.name}</h4>
        <p className="skill-tooltip-description">{subSkill.description}</p>
        {subSkill.experience && (
          <p className="skill-tooltip-experience">
            <strong>Experience:</strong> {subSkill.experience}
          </p>
        )}
        {subSkill.projects && subSkill.projects.length > 0 && (
          <div className="skill-tooltip-projects">
            <strong>Projects:</strong>
            <ul>
              {subSkill.projects.map((project, index) => (
                <li key={index}>{project}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default SkillTooltip;